import Utils from '@/ecm/common/Utils'
export default class DigitalSignature {
    constructor (dto) {
        this.id = 0
        this.name = ''
        this.digitalSignatureProviderId = ''
        this.login = ''
        this.password = ''
        this.clientId = ''
        this.profile = ''
        this.pinNumber = ''

        this.signatureVisible = false
        this.signatureLocationX = 0
        this.signatureLocationY = 0
        this.signatureLocationPage = 1
        this.signatureSizeX = 0
        this.signatureSizeY = 0
        this.signatureIncludeFrame = false

        this.signatureIncludeDescription = false
        this.signatureIncludeUserFullName = false
        this.signatureIncludeTimeStamp = false

        this.signatureIncludeImage = false
        this.useUserSignatureImage = false

        this.signatureIncludeCertificate = false
        this.useUserCertificate = false
        this.selectedSignatureId = null;

        this.signatureImage = null
        this.signatureCertificateFileName = ''
        this.signatureCertificateBase64 = ''

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.digitalSignatureProviderId = dto.DigitalSignatureProviderID + ''
            this.login = dto.Login
            this.password = dto.Password
            this.clientId = dto.ClientID
            this.profile = dto.Profile
            this.pinNumber = dto.PinNumber

            this.signatureVisible = dto.SignatureVisible
            this.signatureLocationX = dto.SignatureLocationX
            this.signatureLocationY = dto.SignatureLocationY
            this.signatureLocationPage = dto.SignatureLocationPage
            this.signatureSizeX = dto.SignatureSizeX
            this.signatureSizeY = dto.SignatureSizeY
            this.signatureIncludeFrame = dto.SignatureIncludeFrame

            this.signatureIncludeDescription = dto.SignatureIncludeDescription
            this.signatureIncludeUserFullName = dto.SignatureIncludeUserFullName
            this.signatureIncludeTimeStamp = dto.SignatureIncludeTimeStamp

            this.signatureIncludeImage = dto.SignatureIncludeImage
            this.useUserSignatureImage = dto.UseUserSignatureImage
            this.selectedSignatureId = dto.SelectedSignatureId;

            this.signatureIncludeCertificate = dto.SignatureIncludeCertificate
            this.useUserCertificate = dto.UseUserCertificate

            this.signatureCertificateFileName = dto.SignatureCertificatePath
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            DigitalSignatureProviderID: parseInt(this.digitalSignatureProviderId),
            Login: this.login,
            Password: this.password,
            ClientID: this.clientId,
            Profile: this.profile,
            PinNumber: this.pinNumber,

            SignatureVisible: this.signatureVisible,
            SignatureLocationX: this.signatureLocationX,
            SignatureLocationY: this.signatureLocationY,
            signatureLocationPage: this.signatureLocationPage,
            SignatureSizeX: this.signatureSizeX,
            SignatureSizeY: this.signatureSizeY,
            SignatureIncludeFrame: this.signatureIncludeFrame,

            SignatureIncludeDescription: this.signatureIncludeDescription,
            SignatureIncludeUserFullName: this.signatureIncludeUserFullName,
            SignatureIncludeTimeStamp: this.signatureIncludeTimeStamp,

            SignatureIncludeImage: this.signatureIncludeImage,
            UseUserSignatureImage: this.useUserSignatureImage,
            SelectedSignatureId: this.selectedSignatureId,

            SignatureIncludeCertificate: this.signatureIncludeCertificate,
            UseUserCertificate: this.useUserCertificate,

            SignatureImage: this.getImage(),
            SignatureCertificate: {
                FileName: this.signatureCertificateFileName,
                Base64File: this.signatureCertificateBase64,
            },
        }
    }

    getImage () {
        if (this.signatureImage) {
            var image = Utils.file.image.getBase64(this.signatureImage)

            return {
                FileName: `signature_img.${image.extension}`,
                Base64File: image.data,
            }
        }
    }
}
